module.exports = __webpack_public_path__ + "band_5.8c1f9451.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_5.png
// module id = Smxf
// module chunks = 0